import {combineEpics} from 'redux-observable';
import appNavBarEpic from './appNavBarEpic';

export default combineEpics(appNavBarEpic);
